<template>
  <div
    class="pt-multimedia-banner py-14"
    :style="`max-height: ${!isNaN(heightBanner) ? `${heightBanner}px` : heightBanner};`"
  >
    <div class="pt-multimedia-banner__overlay" />
    <NuxtImg
      v-if="image"
      :key="image"
      class="pt-multimedia-banner__img"
      :src="image"
      loading="lazy"
      :alt="contentBanner.image?.alternativeText || 'multimedia-banner'"
    />
    <div v-if="title" class="pt-multimedia-banner__container">
      <div v-if="!hasSlot('content')" class="pt-multimedia-banner__wrapperAuthor">
        <h3 class="pt-multimedia-banner__wrapperAuthor--title">
          {{ title }}
        </h3>
        <p class="pt-multimedia-banner__wrapperAuthor--description">
          {{ description }}
        </p>
        <div class="w-full self-center md:self-start">
          <button
            class="justify-center mt-12 btn btn__orange w-52"
            type="button"
            @click.stop.prevent="goToLogin"
          >
            {{ $t('author.subscribeForFree') }}
          </button>
        </div>
      </div>
      <div v-else class="pt-multimedia-banner__wrapper">
        <slot name="content" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SubscribeBanner',
  props: {
    contentBanner: {
      type: Object,
      default: () => ({})
    },
    image: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    heightBanner: {
      type: [String, Number],
      default: 375
    }
  },
  data() {
    const { hasSlot } = useSlot();
    return {
      actualModal: '',
      hasSlot
    };
  },
  methods: {
    goToLogin() {
      this.$msal.signIn(this.$route.path);
    }
  }
};
</script>
<style src="../style.scss" lang="scss" />
